export default __webpack_public_path__ + "static/media/Notification-img.d4028731.svg";